import fetchApi from './api';
import fetchApiBlob from './apiBlob';
import {ApiResponse, LoginResponse, SearchPaging} from 'models/model';
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';



export const SemesterSave = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/SubjectPlanning/Save', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const SemesterGetPaging = async (data: SearchPaging): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/SubjectPlanning/GetPaging', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const SemesterGet = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/SubjectPlanning/Get', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const SemesterGetCourse = async (courseId: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/SubjectPlanning/GetCourse', {
        method: 'POST',
        body: JSON.stringify({ id: courseId })
    });
};

export const SemesterGetLicense = async (licenseClassId: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/SubjectPlanning/GetLicense', {
        method: 'POST',
        body: JSON.stringify({ id: licenseClassId })
    });
};

export const SemesterDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/SubjectPlanning/Delete', {
        method: 'POST',
        body: JSON.stringify({ id })
    });
};

export const SemesterDuplicate = async (licenseClassId: string, courseId: string ): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/SubjectPlanning/Duplicate', {
        method: 'POST',
        body: JSON.stringify({ licenseClassId, courseId })
    });
}

export const SemesterExport = async (data: any): Promise<any> => {
    return fetchApiBlob<any>('/SubjectPlanning/Export', {
        body: JSON.stringify(data),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    });
}

